const parseHTTPResponse = res => {
  if (!res.ok)
    throw Error(`Error ${res.status}: ${res.statusText}`)
  return res.json()
}

export default parseHTTPResponse
